/* ################################################################### */
/* FUNCTION (STICKY HEADER) ########################################## */
/* ################################################################### */
function stickyHeader()
{
	if(jQuery('#header').hasClass('is-sticky'))
	{
		jQuery('#wrapper, #gallery').css(
		{
			'padding-top' : jQuery('#header').outerHeight(true),
			'box-sizing'  : 'border-box'
		});
	}
}
